import styled from 'styled-components/macro';
import { rgba } from 'polished';
import { COLORS } from 'styleguide';

const NotFoundWrapper = styled.div`
  height: 416px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -6px 16px 0 inset ${rgba(COLORS.black, 0.6)};
  background-color: ${COLORS.gray40};
`;

export default NotFoundWrapper;
